export var TimesTypes;
(function (TimesTypes) {
    TimesTypes["game"] = "game";
    TimesTypes["total"] = "total";
})(TimesTypes || (TimesTypes = {}));
export var RoundingType;
(function (RoundingType) {
    RoundingType["round"] = "round";
    RoundingType["floor"] = "floor";
    RoundingType["ceil"] = "ceil";
})(RoundingType || (RoundingType = {}));
//# sourceMappingURL=times.js.map